// Tech doc can be found here
// https://hello.atlassian.net/wiki/spaces/MARTECH/pages/159733334/ConsentHub+Application+Technical+Design

import * as envs from './envs';

interface Environment {
  name: string;
  url: string;
}

const localEnvironment: Environment = {
  name: envs.LOCAL,
  url: 'http://localhost:8080',
};

const devEnvironment: Environment = {
  name: envs.DEV,
  url: 'https://preferences.dev.atlassian.com',
};

const stageEnvironment: Environment = {
  name: envs.STAGE,
  url: 'https://preferences.stg.atlassian.com',
};

const prodEnvironment: Environment = {
  name: envs.PROD,
  url: 'https://preferences.atlassian.com',
};

export const environment = (): Environment => {
  const { hostname } = window.location;
  if ([/\.prod\./, /preferences\.atlassian\.com/].some((r) => r.test(hostname))) {
    return prodEnvironment;
  } else if ([/\.staging\./, /\.stg\./].some((r) => r.test(hostname))) {
    return stageEnvironment;
  } else if ([/\.dev\./].some((r) => r.test(hostname))) {
    return devEnvironment;
  } else if ([/localhost/].some((r) => r.test(hostname))) {
    return localEnvironment;
  } else {
    throw Error('Unable to determine environment');
  }
};
